module.exports = __webpack_public_path__ + "img/home-pedidos.fb71c49e.png";